import { createSlice } from '@reduxjs/toolkit';
import {getPaymentMethodsAsync} from './Actions';

export interface PaymentMethodsValues {
  value: string; 
  label: string; 
}

export interface PaymentMethodsState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<PaymentMethodsValues>;
  errorMessage: string | undefined;
}

const initialState: PaymentMethodsState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const paymentMethodsSlice = createSlice({
  name: 'PaymentMethods',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethodsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getPaymentMethodsAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getPaymentMethodsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default paymentMethodsSlice.reducer;
